module.exports = __webpack_public_path__ + "fc1e2c9f12c4ce5cf87a8db092670ac0.pdf";